import store from '../store'

//初始化数据
function initData() {
  let that = this
  let db = store.getters.webDB
  if (db == null) {
    return
  }
  //初始化用户数据
  let user = JSON.parse(sessionStorage.getItem('user'))
  let version = localStorage.getItem('version')
  store.commit('SET_VERSION', version == null ? 0 : version)
  store.dispatch('setUser', user)

  //获取用户的配置
  let warningTone = localStorage.getItem(user.accountNo + '_warningTone')
  let isPlay = warningTone == undefined ? true : warningTone;
  store.commit('SET_IS_PLAYING', isPlay == 'false' ? false : true)

  let serviceMsgWarn = localStorage.getItem(user.accountNo + '_serviceMsgWarn')
  serviceMsgWarn = serviceMsgWarn == undefined ? true : serviceMsgWarn;
  store.commit('SET_SERVICE_MSG_WARN', serviceMsgWarn == 'false' ? false : true)

  let platformMsgWarn = localStorage.getItem(user.accountNo + '_platformMsgWarn')
  platformMsgWarn = platformMsgWarn == undefined ? true : platformMsgWarn;
  store.commit('SET_PLATFORM_MSG_WARN', platformMsgWarn == 'false' ? false : true)

  //清除消息列表数据。防止重复添加
  store.commit('CLEAR_SESSIONS')

  //数据初始化
  db.iterate(function (value, key, iterationNumber) {
    // 此回调函数将对所有 key/value 键值对运行
    let item = {
      id: value.id,
      msgNum: value.msgNum,
      user: value.user,
      lastDate: value.lastDate,
      platformId: value.platformId
    }
    store.dispatch('setSessions', item)

    store.commit('SORT_SESSIONS')
  }).then(function () {
  }).catch(function (err) {
    // 当出错时，此处代码运行
    console.log(err)
  })
}


export {
  initData
}
